module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "Epigram ParaOverride-1"
  }, [_c('span', {
    staticClass: "epigraph CharOverride-9"
  }, [_vm._v("But if you think that by hanging us you can stamp out the labor ")]), _c('span', {
    staticClass: "epigraph CharOverride-9"
  }, [_vm._v("movement—the movement from which the downtrodden millions, the millions")]), _c('span', {
    staticClass: "epigraph CharOverride-9"
  }), _c('span', {
    staticClass: "epigraph CharOverride-9"
  }, [_vm._v("who toil and live in want and misery, the wage slaves, expect salvation—if ")]), _c('span', {
    staticClass: "epigraph CharOverride-9"
  }, [_vm._v("this is your opinion, then hang us! Here you will tread upon a spark, but here, and ")]), _c('span', {
    staticClass: "epigraph CharOverride-9"
  }, [_vm._v("there and behind you, and in front of you, and everywhere the flames will blaze up.")]), _c('span', {
    staticClass: "epigraph CharOverride-9"
  }, [_vm._v(" It is a subterranean fire. You cannot put it out. The ground is on fire upon which you stand.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-after-subhead ParaOverride-3"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("—August Spies, ")]), _c('span', {
    staticClass: "attribution _idGenCharOverride-1"
  }, [_vm._v("Haymarket")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(" martyr, speech at trial, October 7, 1886")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76c0395a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/epi1.vue
// module id = 72
// module chunks = 0